import {TableColumnDefinition} from '@ft/core';

export const PRINTERS_COLUMNS: TableColumnDefinition[] = [
    {label: 'printing.profile.label', key: 'label', type: 'text'},
    {label: 'printing.profile.printer_name', key: 'printer_name', type: 'text'},
    {label: 'printing.profile.page_size', key: 'page_size', type: 'text'},
    {label: 'printing.profile.extra_args', key: 'extra_args', type: 'text'},
];
